'use client';

import { useFormContext, useWatch } from 'react-hook-form';

import { FulfillmentTile, getSthFulfillmentStatus } from '@libs/shared-ui';

import { isDeliveryMethodAvailable, useProduct } from '@/entities/product';
import { type FormFields, usePurchaseFormWatch } from '@/entities/purchase-form';

export const SthDeliveryTile = () => {
    const { control, register } = useFormContext<FormFields>();

    const { product, tailored, isLoading, isError } = useProduct();
    const selectedPurchaseOption = usePurchaseFormWatch('purchaseOption');
    const selectedDeliveryMethod = useWatch({ control, name: 'fulfilmentMethod' });

    // Check if STH is available for the current purchase option
    const isSthAvailable = isDeliveryMethodAvailable({
        deliveryMethodName: 'STH',
        deliveryMethodData: product?.deliveryMethods?.STH,
        purchaseOption: selectedPurchaseOption ?? 'one-time',
    });

    const isDisabled = !isLoading && !isSthAvailable;

    const sthStock = product?.sku && !isError ? (tailored?.variants?.[product.sku]?.STH?.availableStock ?? 0) : 0;

    const status = getSthFulfillmentStatus({
        availableStock: sthStock,
        minimumCaseQty: product?.deliveryMethods?.STH?.purchaseQuantities?.min ?? 1,
        isPharmacyOutOfStock: Boolean(product?.pharmacy?.oos),
    });

    return (
        <FulfillmentTile
            value="sth"
            title="Ship to me"
            iconName="car-outline"
            status={status}
            statusTestId="stm-tile-status-message"
            isSelected={selectedDeliveryMethod === 'sth' && !isLoading && !isDisabled}
            isDisabled={isDisabled}
            isLoading={isLoading}
            inputProps={register('fulfilmentMethod')}
        />
    );
};
